import React, { Suspense, useMemo } from "react";
import DashboardCard from "@/features/dashboard/components/dashboard-card";
import BestSellingHeader from "@/features/dashboard/features/best-selling-section/components/best-selling-header";
import BestSellingGrid from "@/features/dashboard/features/best-selling-section/components/best-selling-grid";
import usePersistedLineSheetSetListQuery from "@/features/dashboard/features/best-selling-section/hooks/useBsQuery";
import DashboardCardSpinner from "@/features/dashboard/components/dashboard-card-spinner";

export default function BestSellingSection({
  showOrderable = true
}) {
  const {
    value: query,
    set: setQuery,
    clear,
  } = usePersistedLineSheetSetListQuery();

  const isOrderable = useMemo(() => query.isOrderable, [query.isOrderable]);

  return (
    <DashboardCard>
      <DashboardCard.Header>
        <BestSellingHeader query={query} setQuery={setQuery} clear={clear} showOrderable={showOrderable} />
      </DashboardCard.Header>
      <DashboardCard.Body isScrollable={true}>
        <Suspense fallback={<DashboardCardSpinner />}>
          <BestSellingGrid
            showOrderable={showOrderable}
            isOrderable={isOrderable}
            clear={clear}
          />
        </Suspense>
      </DashboardCard.Body>
    </DashboardCard>
  );
}
